import React, { createContext, useState } from 'react'

export const RatesAuthContext = createContext()

export const RatesAuthProvider = ({ children }) => {
  const [isRatesAuthenticated, setIsRatesAuthenticated] = useState(false)

  return (
    <RatesAuthContext.Provider value={{ isRatesAuthenticated, setIsRatesAuthenticated }}>
      {children}
    </RatesAuthContext.Provider>
  )
}
